<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-100 md-small-size-100 md-xsmall-size-100 text-center"
          >
            <h1 class="title">Packages
              <br>
              <small class="text-white">Welcome to be here!</small>
            </h1>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section section-middle">
        <div class="container">
          <div class="elevation-demo">
            <md-content class="md-elevation">
              <div class="md-layout-item md-size-80 text-left">
                <h3 class="title text-center">Banquet Halls</h3>
                <h5 class="text-left">Days Inn Hotel Banquet Hall, Sherman TX - #1 Best Value Hotel in Sherman Rated by Tripadvisor.com! Meeting/Party space rental for Birthday party, Wedding Venues, Business meeting, Family Reunion, Holidays, Conventions, Corporate Meetings, Anniversary Parties, Bridal Showers, Receptions place, Retirement Parties, Conference Rooms or any type of social functions, gatherings and occasions. We have sittings for up to 250 guests. LOW RATES!</h5>
                <md-button
                  href="/meetingRooms"
                  class="md-success md-lg"
                  target="_self"
                  ><md-icon>info</md-icon>Learn More
                </md-button>
              </div>
            </md-content>
            <md-content class="md-elevation">
              <img
                :src="img1"
                alt="Banquet Hall"
                class="img-raised"
              />
            </md-content>
            <md-content class="md-elevation">
              <img
                :src="img2"
                alt="Guest room"
                class="img-raised"
              />
            </md-content>
            <md-content class="md-elevation">
              <div class="md-layout-item md-size-80 text-center">
                <h3 class="title">Guest Rooms</h3>
                <h5 class="text-left">Furnished Studio $995/Month - Best rate in Sherman! <br>Take advantage of our special discounted rate! All utilities are included! No credit, no lease needed!<br>
                Looking for a place to call home for a couple months or longer? We have everything you need without the hassles of traditional apartments, all at a great rate. Each room comes with plenty of workspace. And unlike apartments, cable and Wi-Fi are already hooked up and free! With no leases and no credit checks, we are move-in ready. So just bring yourself - and your furry family member - and feel right at home.<br> </h5>
                <md-button
                  href="/guestRooms"
                  class="md-success md-lg"
                  target="_self"
                  ><md-icon>info</md-icon>Learn More
                </md-button>
              </div>
            </md-content>
            <md-content class="md-elevation">
              <div class="md-layout-item md-size-80 text-center">
                <h3 class="title">Restaurant</h3>
                <h5 class="text-left">The heart & soul of this property is the Bar & Restaurant, OrangeTree, offering fine dining in a casual, cozy atmosphere. Add to this a carefully curated wine list, craft beers and cocktails. Grab a cocktail at our bar, and enjoy a bite to eat from the OrangeTree. It’s a truly memorable dining experience you won’t want to miss. </h5>
                <md-button
                  href="/kitchen"
                  class="md-success md-lg"
                  target="_self"
                  ><md-icon>info</md-icon>Learn More
                </md-button>
              </div>
            </md-content>
            <md-content class="md-elevation">
              <img
                :src="img3"
                alt="Restaurant"
                class="img-raised"
              />
            </md-content>
          </div>
        </div>
      </div>
      <hr>
      <div class="section section-bottom">
        <div class="container">
          <div class="md-layout-item md-size-100 text-center">
            <h3 class="title">Enjoy Your Package Today!</h3>
            <h5>If you have requests for specific accessibility needs, please contact us with the special requests. </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
export default {
  components: {
    Modal
  },
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/package_header.jpg")
    },
    menuImg: {
      type: String,
      default: require("@/assets/img/vintage Menu card.jpg")
    },
    menuImg1: {
      type: String,
      default: require("@/assets/img/bar-menu.jpg")
    },
    menuImg2: {
      type: String,
      default: require("@/assets/img/bar-menu2.jpg")
    },
    ourRoom: {
      type: String,
      default: require("@/assets/img/SND2_2.jpg")
    },
    ourView: {
      type: String,
      default: require("@/assets/img/Extra_Court_Yard1.jpg")
    },
    img1: {
      type: String,
      default: require("@/assets/img/package_banquet.jpg")
    },
    img2: {
      type: String,
      default: require("@/assets/img/package_guest.jpg")
    },
    img3: {
      type: String,
      default: require("@/assets/img/m3.jpg")
    },
    img4: {
      type: String,
      default: require("@/assets/img/m4.jpg")
    },
    img5: {
      type: String,
      default: require("@/assets/img/m5.jpg")
    },
    img6: {
      type: String,
      default: require("@/assets/img/m6.jpg")
    },
    img7: {
      type: String,
      default: require("@/assets/img/m7.jpg")
    },
    img8: {
      type: String,
      default: require("@/assets/img/m3.jpg")
    },
    img9: {
      type: String,
      default: require("@/assets/img/m4.jpg")
    },
    img10: {
      type: String,
      default: require("@/assets/img/m5.jpg")
    },
    img11: {
      type: String,
      default: require("@/assets/img/m6.jpg")
    },
    img12: {
      type: String,
      default: require("@/assets/img/m7.jpg")
    }
  },
  data() {
    return {
      classicModal: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false
      },
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    classicModalHide(e) {
      this.classicModal[e] = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 40px;
}
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.page-header {
  b {
    font-size: 4.2rem
  }
}
.info{
  padding-top: 20px;
}
.elevation-demo {
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
}
.t_img1 {
  margin-top: 58px;
}
hr {
  margin-top: 1rem;
  // margin-bottom: 0.5rem;
  border: 0;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.md-elevation {
  height: auto;
  // margin: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    width: 100%;
    height: 100%;
    position: relative;
    // i {
    //   display: table-cell;
    //   position: absolute;
    //   top:0;
    //   right: 0;
    //   bottom: 0;
    //   left: 0;
    //   font-size: 2.0rem;
    //   font-weight: bold;
    //   vertical-align: middle;
    //   text-align: center;
    //   font-style: normal; 
    //   background: rgba(245, 124, 0, 0.5);
    //   color: #fff;
    //   opacity: 0;
    //   z-index: 9;
    //   padding: 50% 0 0 0;
    //   transition: opacity 0.4s ease 0s;
    // }
    // &:hover {
    //   i {
    //     opacity: 1;
    //   }
    // }
  }
}
.section-middle .md-elevation {
  width: 50%;
}
.section-bottom .md-elevation {
  width: 20%;
}
@media (max-width: 768px){
  .section-middle .md-elevation, .section-bottom .md-elevation {
    width: 100%;
  }
}
</style>
